// extracted by mini-css-extract-plugin
export var addViewLink = "_o-1";
export var availabilityIcon = "_o-16";
export var availabilitySelectionIcon = "_o-15";
export var backButton = "_o-2";
export var backIcon = "_o-z";
export var conversationCount = "_o-3";
export var dragHandle = "_o-5";
export var dropdown = "_o-e";
export var dropdownIcon = "_o-7";
export var dropdownOption = "_o-6";
export var dropdownTriangle = "_o-d";
export var expand = "_o-f";
export var folder = "_o-i";
export var folderItem = "_o-c";
export var icon = "_o-8";
export var iconRow = "_o-9";
export var image = "_o-a";
export var logo = "_o-b";
export var navContainer = "_o-h";
export var navigationFooter = "_o-g";
export var pageShell = "_o-0";
export var placeholderAvailable = "_o-11";
export var placeholderBox = "_o-14";
export var placeholderBusy = "_o-13";
export var placeholderUnavailable = "_o-12";
export var profile = "_o-k";
export var profileContainer = "_o-m";
export var profileDropdown = "_o-n";
export var profileImage = "_o-l";
export var profileMain = "_o-o";
export var profileSubtitle = "_o-q";
export var profileTitle = "_o-p";
export var reorderIcon = "_o-r";
export var sentLine = "_o-u";
export var settingsHeader = "_o-s";
export var sidenavTextColor = "_o-y";
export var spamLine = "_o-t";
export var subitemWithTag = "_o-4";
export var supportItems = "_o-j";
export var teamText = "_o-10";
export var viewLine = "_o-x";
export var viewLineButton = "_o-w";
export var viewLineButtons = "_o-v";